import styled from "@emotion/styled";
import tw from "tailwind.macro";

export const ProductListStyled = styled.div`
    ${tw`flex flex-wrap items-center `};
`;
